import $ from 'jquery';

const sendData = (e, form, file = false) => {
	e.preventDefault();
	const type = form.attr('method');
	const url = form.attr('action');
	const data = file ? new FormData(form[0]) : form.serialize();
	return $.when($.ajax( {
		type,
		url,
		data,
		processData: false
	}));
};

export default sendData;



/** WEBPACK FOOTER **
 ** ./app/scripts/util/request/sendData.js
 **/